<template>
  <div>
    <slot name="H-title" />
    <slot name="H-right-wrapper" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
</style>